exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cursor-pointer[data-v-f1a945a8]{cursor:pointer}", ""]);

// exports
